import React, { useEffect, useState } from 'react';
import { getMe, regenerateKey } from '../api';

const s = {
    h1:   { fontSize: 22, fontWeight: 700, marginBottom: 20 },
    box:  { background: '#fff', borderRadius: 10, padding: 28, boxShadow: '0 1px 4px rgba(0,0,0,.06)', maxWidth: 680 },
    row:  { marginBottom: 20 },
    lbl:  { fontSize: 12, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 6, display: 'block' },
    val:  { fontSize: 14, color: '#1a1d23', padding: '10px 14px', background: '#f9fafb', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 10 },
    code: { fontFamily: 'monospace', fontSize: 13, flex: 1, wordBreak: 'break-all' },
    copy: { flexShrink: 0, padding: '4px 10px', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer', fontSize: 12, background: '#fff' },
    btn:  { padding: '10px 20px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 13 },
    warn: { marginTop: 10, fontSize: 12, color: '#6b7280' },
    note: { marginTop: 20, padding: '16px 20px', background: '#f0f4ff', borderRadius: 10, fontSize: 13, lineHeight: 1.8 },
    pre:  { background: '#1a1d23', color: '#a5f3fc', padding: 16, borderRadius: 8, fontSize: 12, fontFamily: 'monospace', overflow: 'auto', marginTop: 8 },
};

export default function ApiKey() {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [regen, setRegen] = useState(false);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        getMe().then(r => setMe(r.data)).catch(console.error).finally(() => setLoading(false));
    }, []);

    const copy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const doRegen = async () => {
        if (!window.confirm('Regenerate API key? Old key will stop working immediately.')) return;
        setRegen(true);
        try {
            const res = await regenerateKey();
            setMe(prev => ({ ...prev, api_key: res.data.api_key }));
        } catch (e) {
            alert('Failed to regenerate key');
        } finally {
            setRegen(false);
        }
    };

    if (loading) return <div>Loading...</div>;

    const panelUrl = window.location.origin;

    return (
        <div>
            <h1 style={s.h1}>API Key</h1>
            <div style={{ background: '#422006', border: '1px solid #f59e0b', borderRadius: 8, padding: '14px 18px', marginBottom: 16, color: '#fcd34d', fontWeight: 600, lineHeight: 1.5 }}>
                ⚠️ BE SURE TO TURN ON AUTO-SYNC for OrbitGrowth in your panel's provider settings — otherwise our price updates won't reach your panel and you may sell at outdated rates.
            </div>
            <div style={s.box}>
                <div style={s.row}>
                    <span style={s.lbl}>Your API Key</span>
                    <div style={s.val}>
                        <span style={s.code}>{me?.api_key || '—'}</span>
                        <button style={s.copy} onClick={() => copy(me?.api_key)}>
                            {copied ? '✓ Copied' : 'Copy'}
                        </button>
                    </div>
                </div>

                <button style={s.btn} onClick={doRegen} disabled={regen}>
                    {regen ? 'Regenerating...' : '🔄 Regenerate Key'}
                </button>
                <div style={s.warn}>Warning: regenerating invalidates the current key immediately.</div>

                <div style={s.note}>
                    <strong>What is this key for?</strong><br />
                    Use this API key to connect OrbitGrowth to your own SMM reseller panel, automation tool, or custom software.
                    Add OrbitGrowth as a <em>provider</em> in your platform by entering the endpoint URL and this key — you can then place orders, check balances and statuses directly from your tool, without logging in here.<br /><br />
                    <strong>API Endpoint (PerfectPanel / SMMKings compatible):</strong><br />
                    <code>{panelUrl}/api/v2</code>
                    <pre style={s.pre}>{`# List available services
curl -X POST ${panelUrl}/api/v2 \\
  -d "key=${me?.api_key}&action=services"

# Place an order
curl -X POST ${panelUrl}/api/v2 \\
  -d "key=${me?.api_key}&action=add&service=1017&link=https://instagram.com/p/ABC123/&quantity=100"

# Check order status
curl -X POST ${panelUrl}/api/v2 \\
  -d "key=${me?.api_key}&action=status&order=42"

# Check your balance
curl -X POST ${panelUrl}/api/v2 \\
  -d "key=${me?.api_key}&action=balance"`}</pre>
                    <span style={{ color: '#6b7280' }}>
                        Compatible with any reseller software that supports the PerfectPanel / SMMKings API format.
                        Simply add a new provider, paste the endpoint URL above, and paste your key.
                    </span>
                </div>
            </div>
        </div>
    );
}
